import React from 'react';
import ExportDropdown from './ExportDropdown';
import './styles/exportDropdown.css';

const SetupActions = ({ locations, handleReset }) => {
  if (locations.length === 0) return null;
  
  return (
    <div className="setup-actions">
      <ExportDropdown locations={locations} />
      <button 
        className="reset-btn"
        onClick={handleReset}
      >
        Reset All
      </button>
    </div>
  );
};

export default SetupActions; 